import React, { Fragment, ReactElement } from 'react';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from './configuration';
import { Button, Typography } from '@material-ui/core';
import useStyles from './styles';
import AddIcon from '@material-ui/icons/Add';
import DatatableList from './components/datatable';
import { useDispatch } from 'react-redux';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import * as VatReturnDetailsSelectors from 'redux/reducers/vatReturn_detail_reducer/selectors';
import { StateStatus } from 'redux/utils/common';
import { SchemeTypes } from 'config';

interface ICountry {
  country_id: number;
  country: string;
}

interface ICountriesWithVatRate {
  data: Array<ICountry>;
  status: StateStatus;
}

interface IProps {
  mode: 'VIEW' | 'EDIT';
  // countries: ICountriesWithVatRate;
  vat_return_id: number;
  schemeType: SchemeTypes;
}

export default function CorrectionsOfVatReturn(props: IProps): ReactElement {
  // console.log('Render CorrectionsOfVatReturn');
  const mode = props.mode;
  const classes = useStyles();
  const dispatch = useDispatch();

  const result = VatReturnDetailsSelectors.useGetVatCorrections();

  return (
    <Fragment>
      <div className={classes.header_container}>
        <Typography variant="h5">
          <TranslatedText textMap={Translations.header} />
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          disabled={mode === 'VIEW'}
          onClick={() => {
            dispatch(
              ModalActions.openModalAction({
                modalID: ModalIDs.MODAL_ADD_VAT_RETURN_CORRECTIONS,
                params: {
                  vat_return_id: props.vat_return_id,
                  schemeType: props.schemeType,
                },
              })
            );
          }}
        >
          <TranslatedText textMap={Translations.add_correction} />
        </Button>
      </div>
      <DatatableList mode={mode} data={result || []} />
    </Fragment>
  );
}
